<template>
  <span>
    <span class="rpg-btn rpg-btn-outline" @click="showFile">查看合同附件</span>
    <el-dialog title="合同附件列表" :append-to-body="true" :close-on-click-modal="false" :modal="false" :visible.sync="listVisible">
      <FileTable v-if="listVisible" :files="files" :paginate="false" width="600" height="200" />
    </el-dialog>
  </span>
</template>
<script>
import { FileTable } from '../../../file'
import { Popper } from '../../../project'

export default {
  components: { FileTable, Popper },
  props: {
    companyName: String,
  },
  data() {
    return {
      files: [],
      listVisible: false,
    }
  },
  methods: {
    async showFile() {
      if (!this.companyName) return this.$message('未填写客户公司')
      if (this.files.length == 0) {
        const com = await app.service('company').getCompany(this.companyName)
        if (com.status == 200) {
          if (com.result.附件 && com.result.附件.length > 0) {
            const attachs = com.result.附件.filter(a => a.type == '合同')
            this.files = attachs || []
            if (attachs.length == 0) {
              return this.$message('无合同附件')
            } else if (attachs.length == 1) {
              this.preview(attachs[0])
            } else {
              // 弹出列表
              this.listVisible = true
            }
          } else {
            return this.$message('无合同附件')
          }
        } else {
          return this.$message('未找到对应公司')
        }
      }
    },
    async preview(file) {
      const ref = window.app.root.$refs.cvPreview
      if (!ref) return
      await ref.getFile(file)
      ref.show()
    },
  },
}
</script>
